import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const root = document.getElementById('root');
    root.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
